// Shared date helpers for the admin workspaces.
// Dates are stored as plain "YYYY-MM-DD" strings. These helpers keep
// conversions timezone-safe (parsing/formatting at local noon avoids day drift).

export const fmtDate = (d) => (d ? String(d).slice(0, 10) : "\u2014");

export const today = () => new Date().toISOString().slice(0, 10);

export const ymdToDate = (s) => {
  if (!s) return undefined;
  const m = String(s).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return undefined;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0);
};

export const dateToYmd = (d) => {
  if (!d) return "";
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${mo}-${da}`;
};

export const fmtDisplayDate = (s) => {
  const d = ymdToDate(s);
  if (!d) return "";
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};
